module.exports = __webpack_public_path__ + "img/side_seam_back_pocket_position.8b0f1c88.png";